// Update this for quickshop subscription loader.
window.addEventListener('DOMContentLoaded', () => {
  var labels = document.querySelectorAll('.inside-modal label');
  labels.forEach(label => {
    label.addEventListener('click', () => {
      var variantId = label.dataset.variantId;
      const allSubscriptionWidgets = document.querySelectorAll('.subscription-widget__variant');

      allSubscriptionWidgets.forEach(widget => {
        widget.classList.add('hidden');
      });

      var subscriptionWidget = document.querySelector(`.subscription-widget__variant-${variantId}`);
      if (!subscriptionWidget) return;
      subscriptionWidget.classList.remove('hidden');
    });
  });
});